import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, EndCTA } from "../../components/PageParts";

export default function Tarifs() {
  const BC = [{ to: "/", label: "Accueil" }, { to: "/votre-seance", label: "Votre séance" }, { label: "Tarifs" }];
  return (
    <>
      <Seo
        title="Tarifs des séances d'hypnose"
        description="Tarifs des séances d'hypnose avec Valentine DL : 120 € pour l'hypnose régressive et spirituelle (~2h). Cabinet à Pantin ou séance en ligne. Hypnose ericksonienne (80 €) proposée à partir de septembre 2026."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance/tarifs"
      />
      <PageHero breadcrumb={BC} eyebrow="Transparence" title="Tarifs" italic="des séances d'hypnose" />

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to="/hypnose/ericksonienne"
            data-testid="tarif-card-ericksonienne"
            className="group rounded-2xl bg-white/70 border border-sand-300/60 p-8 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-lg hover:border-sand-500/50 relative"
          >
            <p className="eyebrow !text-sand-600 mb-3">Hypnose ericksonienne</p>
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-5xl font-serif font-light text-sand-900">80</span>
              <span className="text-xl text-sand-700 font-serif">€</span>
            </div>
            <p className="mt-2 text-sand-600 text-sm text-center">environ 1h à 1h15</p>
            <p className="mt-4 text-sand-700 text-sm text-center">Stress, anxiété, sommeil, confiance en soi…</p>
            <p className="mt-5 text-center">
              <span className="inline-block rounded-full bg-[#B07A45]/10 border border-[#B07A45]/30 px-3 py-1 text-xs text-[#8A5F32] font-medium italic">
                Ouverture des séances en septembre 2026
              </span>
            </p>
          </Link>
          <Link
            to="/hypnose/spirituelle"
            data-testid="tarif-card-spirituelle"
            className="group rounded-2xl bg-white/70 border border-sand-300/60 p-8 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-lg hover:border-sand-500/50"
          >
            <p className="eyebrow !text-sand-600 mb-3">Hypnose régressive et spirituelle</p>
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-5xl font-serif font-light text-sand-900">120</span>
              <span className="text-xl text-sand-700 font-serif">€</span>
            </div>
            <p className="mt-2 text-sand-600 text-sm text-center">environ 2h</p>
            <p className="mt-4 text-sand-700 text-sm text-center">Sens, cohérence, mémoires, discernement</p>
          </Link>
        </div>

        <div className="max-w-3xl mx-auto mt-12 rounded-2xl bg-sand-200/40 border border-sand-300/60 p-8">
          <p className="eyebrow mb-4">Modalités de règlement</p>
          <ul className="text-sand-700 leading-relaxed space-y-3">
            <li>
              <strong className="text-sand-900 font-medium">Séance en présentiel</strong> (
              <Link to="/votre-seance/cabinet-pantin" className="text-[#B07A45] underline hover:text-sand-900">
                cabinet de Pantin
              </Link>
              )&nbsp;: règlement en fin de séance, en espèces ou par chèque.
            </li>
            <li>
              <strong className="text-sand-900 font-medium">
                <Link to="/votre-seance/en-ligne" className="text-[#B07A45] underline hover:text-sand-900">
                  Séance en ligne
                </Link>
              </strong> (visio)&nbsp;: règlement à la réservation, par virement bancaire ou PayPal.
            </li>
            <li>Une facture peut être fournie sur demande.</li>
          </ul>
        </div>

        <div className="max-w-3xl mx-auto mt-8 text-sand-600 text-sm text-center">
          Les séances d'hypnose que je propose sont des accompagnements de mieux-être et ne sont pas remboursées par la Sécurité sociale. Certaines mutuelles proposent une prise en charge partielle — renseignez-vous auprès de la vôtre.
        </div>
      </section>

      <EndCTA testid="tarifs-end" />
    </>
  );
}
